import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse } from '../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../Login/Actions/LoginAction';
import { Tabs, Tab } from 'react-bootstrap';
import * as UserController from '../Controller/UserController';
import Utility from '../../Utility/Utility';
import ConfirmationAlert from '../../Utility/Components/ConfirmationAlert';
import ModalGlobal from '../../Utility/Components/ModalGlobal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Personal from '../Components/Personal/Personal';
import Professional from '../Components/Professional/Professional';
import ImageCropContent from '../../Utility/Components/ImageCropContent';
import ErrorBoundary from '../../Utility/Components/ErrorBoundary';
import { withNamespaces } from 'react-i18next';
import '../Assets/css/profiledoc.scss';
import defaultImg from '../../Utility/Public/images/blank_img.png';

const UserProfile = ({
  t,
  profilecontentdispaly,
  selectedRowsData,
  // paramsData,
  userProfileId,
  roleWisePermission,
  loaderStateTrue,
  loaderStateFalse,
  backToWorker,
  userCredentials
}) => {
  // State management

  const [selectedTabName, setSelectedTabName] = useState("personal");
  const [tabChangeConfirmModal, setTabChangeConfirmModal] = useState(false);
  const [tabchangeInner, setTabchangeInner] = useState(false);
  const [tempTabName, setTempTabName] = useState("");
  const [backToWorkerConfirmed, setBackToWorkerConfirmed] = useState(false);
  const [confirmationAlertModal, setConfirmationAlertModal] = useState(false);
  const [resetconfirmationAlertModal, setResetconfirmationAlertModal] = useState(false);

  // User data state
  const [userName, setUserName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userStatus, setUserStatus] = useState("");

  // Profile image state
  const [profileImagePreviewShow, setProfileImagePreviewShow] = useState(false);
  const [profileImage, setProfileImage] = useState("");
  const [existingProfileImage, setExistingProfileImage] = useState(defaultImg);
  const [workerFormData, setWorkerFormData] = useState({
    profileImage: {
      "file_name": "",
      "file_obj": ""
    }
  });
  const [profileImageError, setProfileImageError] = useState("");

  // Image crop state
  const [src, setSrc] = useState(null);
  const [crop, setCrop] = useState({
    unit: '%',
    width: 30,
  });
  const [croppedImageUrl, setCroppedImageUrl] = useState("");
  const [imageCropModalFlag, setImageCropModalFlag] = useState(false);
  const [image_upload_success, setImageUploadSuccess] = useState(false);

  // Refs
  const imageRef = useRef(null);

  // Memoized role permissions
  const rolePermissions = useMemo(() => {
    const personal = Object.keys(Utility.getRoleObjectByEventKey('user_profile')).length > 0 &&
      Utility.getRoleObjectByEventKey('user_profile').subeventKey.length > 0 &&
      Utility.getRoleObjectByEventKey('user_profile').subeventKey[0].eventKey == "personal" &&
      (Utility.getRoleObjectByEventKey('user_profile').subeventKey[0].rules == "CRUD" ||
        Utility.getRoleObjectByEventKey('user_profile').subeventKey[0].rules == "CUD" ||
        Utility.getRoleObjectByEventKey('user_profile').subeventKey[0].rules == "RUD");

    const professional = Object.keys(Utility.getRoleObjectByEventKey('user_profile')).length > 0 &&
      Utility.getRoleObjectByEventKey('user_profile').subeventKey.length > 0 &&
      Utility.getRoleObjectByEventKey('user_profile').subeventKey[1].eventKey == "professional" &&
      (Utility.getRoleObjectByEventKey('user_profile').subeventKey[1].rules == "CRUD" ||
        Utility.getRoleObjectByEventKey('user_profile').subeventKey[1].rules == "CUD" ||
        Utility.getRoleObjectByEventKey('user_profile').subeventKey[1].rules == "RUD");

    return { personal, professional };
  }, []);

  const setUserDetails = useCallback((workerDetails) => {    
    // Parse the JSON string to get the image URL
    let profileImageData = defaultImg;
    if (workerDetails.profile_img_url) {
      try {
        const parsed = JSON.parse(workerDetails.profile_img_url);
        profileImageData = parsed.img_url || defaultImg;
      } catch (e) {
        profileImageData = workerDetails.profile_img_url || defaultImg;
      }
    }
    setUserName(Utility.displayNameFormat(workerDetails.first_name, workerDetails.last_name));
    setPhoneNumber(workerDetails.contact_number);
    setProfileImage(profileImageData);
    setUserEmail(workerDetails.email);
    setUserStatus(workerDetails.active);
    setExistingProfileImage(profileImageData);
  }, []);

  useEffect(() => {
    setUserDetails(selectedRowsData);
    if (rolePermissions.personal) {
      setSelectedTabName("personal");
    } else if (rolePermissions.professional) {
      setSelectedTabName("professional");
    }
  }, []);

  // Phone number update success callback
  const phoneNumberUpdateSuccessFn = useCallback((data) => {
    if (data?.contact) {
      let contact = data.contact;
      if (!contact.includes('+') && contact) {
        contact = '+' + contact;
      }
      setPhoneNumber(contact);
    }
  }, []);

  // Tab change handlers
  const openTabChangeConfirmModal = useCallback(() => {
    setTabChangeConfirmModal(true);
  }, []);

  const tabChangeConfirmModalHide = useCallback(() => {
    setTabChangeConfirmModal(false);
    setTempTabName("");
  }, []);

  const handelSelectTab = useCallback((tabName) => {
    if (tabchangeInner) {
      setTempTabName(tabName);
      openTabChangeConfirmModal();
    } else {
      setSelectedTabName(tabName);
    }
  }, [tabchangeInner, openTabChangeConfirmModal]);

  const confirmTabChange = useCallback(() => {
    if (!backToWorkerConfirmed) {
      setSelectedTabName(tempTabName);
      setTabchangeInner(false);
      tabChangeConfirmModalHide();
    } else {
      tabChangeConfirmModalHide();
      backToWorker();
    }
  }, [backToWorkerConfirmed, tempTabName, tabChangeConfirmModalHide, backToWorker]);

  const backToWorkerHandler = useCallback(() => {
    setBackToWorkerConfirmed(true);
    if (tabchangeInner) {
      openTabChangeConfirmModal();
    } else {
      backToWorker();
    }
  }, [tabchangeInner, openTabChangeConfirmModal, backToWorker]);
  // Profile image UI component
  const profileImageUi = useCallback(() => {
    const userInitials = selectedRowsData?.first_name?.charAt(0) + selectedRowsData?.last_name?.charAt(0);

    return (
      <label className="custom-file-upload">
        {profileImage ? (
          (() => {
            return <img src={profileImage} alt="Profile" />;
          })()
        ) : (
          (() => {
            return (
              <div className="user_name_box_profile_con">
                <img src={defaultImg} alt="Default" />
                <div className="user_name_label">{userInitials}</div>
              </div>
            );
          })()
        )}

        {(rolePermissions.personal || rolePermissions.professional) && (
          (() => {
            return (
              <>
                <input
                  type="file"
                  accept={Utility.acceptFileType()}
                  onChange={profileImageChanged}
                />
                <div className="hoverlayerbackground">
                  <div className="hoverContent">
                    <img
                      src={require('../../Utility/Public/images/cameraicon.png')}
                      className="cameraicon"
                      alt="Camera"
                    />
                    <p>{t('uploadphoto')}</p>
                  </div>
                </div>
              </>
            );
          })()
        )}
      </label>
    );
  }, [profileImage]);

  // Profile image change handler
  const profileImageChanged = useCallback((event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = Utility.acceptFileType();

    Utility.checkFileType(file, allowedTypes)
      .then(results => {
        if (!results.isValid) {
          setWorkerFormData(prev => ({ ...prev, profileImage: {} }));
          setProfileImageError("Required field");
          setProfileImagePreviewShow(false);
          setProfileImage(existingProfileImage);
          Utility.toastNotifications("File format is not supported, it should be in jpg, jpeg or png format", "Warning", "warning");
          return;
        }

        const fileSize = Math.round(file.size / 1024);
        if (fileSize >= 300) {
          Utility.toastNotifications("Image size should be less than 300 KB", "Warning", "warning");
          return;
        }

        const reader = new FileReader();
        reader.onload = () => {
          setSrc(reader.result);
          setImageCropModalFlag(true);
        };
        reader.readAsDataURL(file);

        const user_profile_image = {
          "file_name": file.name,
          "file_obj": ""
        };

        setWorkerFormData(prev => ({
          ...prev,
          profileImage: user_profile_image
        }));
        setProfileImagePreviewShow(true);
        setProfileImageError("");
        setTabchangeInner(true);
      })
      .catch(error => {
        console.error("Error checking file type:", error);
      });
  }, []);

  // Format worker data for submission
  const formatWorkerData = useCallback(() => {
    return {
      'profile_img_url': workerFormData.profileImage
    };
  }, [workerFormData]);

  // Submit worker profile
  const submitWorkerProfile = useCallback(async () => {
    if (Object.keys(workerFormData.profileImage).length === 0) {
      Utility.toastNotifications("Profile image cannot be blank", "Error", "error");
      return;
    }

    const dataset = formatWorkerData();
    loaderStateTrue();

    try {
      const response = await UserController.users(dataset, userProfileId);
      if (response.success) {
        if (workerFormData.profileImage?.file_obj) {
          const imageUrl = workerFormData.profileImage.file_obj.startsWith('data:')
            ? workerFormData.profileImage.file_obj
            : `data:image/jpeg;base64,${workerFormData.profileImage.file_obj}`;

          setProfileImage(imageUrl);
          setExistingProfileImage(imageUrl);
          setProfileImagePreviewShow(false);
          setTabchangeInner(false);
          setImageUploadSuccess(false);
          Utility.toastNotifications(response.message, "Success", "success");
        } else {
          setProfileImagePreviewShow(false);
          setTabchangeInner(false);
          setImageUploadSuccess(false);
          Utility.toastNotifications(response.message, "Success", "success");
        }
      } else {
        Utility.toastNotifications(response.message, "Error", "error");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    } finally {
      loaderStateFalse();
    }
  }, [workerFormData, formatWorkerData, loaderStateTrue, loaderStateFalse]);

  // Cancel worker profile changes
  const cancelWorkerProfile = useCallback(() => {
    setProfileImagePreviewShow(false);
    setImageUploadSuccess(false);
    setProfileImage(existingProfileImage);
  }, [existingProfileImage]);

  // Image crop handlers
  const onImageLoaded = useCallback((image) => {
    imageRef.current = image;
  }, []);

  const onCropComplete = useCallback((crop) => {
    makeClientCrop(crop);
  }, []);

  const onCropChange = useCallback((crop) => {
    setCrop(crop);
  }, []);

  // Make client crop
  const makeClientCrop = useCallback(async (crop) => {
    if (!imageRef.current || !crop.width || !crop.height) return;

    const canvas = document.createElement('canvas');
    const pixelRatio = window.devicePixelRatio;
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    const ctx = canvas.getContext('2d');

    canvas.width = crop.width * pixelRatio * scaleX;
    canvas.height = crop.height * pixelRatio * scaleY;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = 'high';

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    const base64Image = canvas.toDataURL('image/jpeg');
    const base64Data = base64Image.replace(/^data:[^,]+,/, '');
    const decodedSize = (base64Data.length * 3) / 4;

    if (decodedSize <= 300 * 1024) {
      setProfileImage(base64Image);
      setWorkerFormData(prev => ({
        ...prev,
        profileImage: {
          ...prev.profileImage,
          "file_obj": base64Image
        }
      }));
    } else {
      Utility.toastNotifications("File is too Big, please select a file less than 300kb", "Warning", "warning");
    }
  }, [ setWorkerFormData]);

  // Image crop modal handlers
  const imageCropModalHide = useCallback(() => {
    if (existingProfileImage && existingProfileImage !== defaultImg) {
      setWorkerFormData(prev => ({
        ...prev,
        profileImage: {
          "file_name": "",
          "file_obj": existingProfileImage
        }
      }));
    } else {
      setWorkerFormData(prev => ({ ...prev, profileImage: {} }));
    }

    setImageCropModalFlag(false);
    setProfileImage(existingProfileImage || defaultImg);
    setProfileImageError("");
    setProfileImagePreviewShow(false);
    setTabchangeInner(false);
  }, [existingProfileImage]);

  const imageCropDataSave = useCallback(() => {
    setImageCropModalFlag(false);
    setImageUploadSuccess(true);
  }, []);

  // Delete user handlers
  const deleteUser = useCallback(() => {
    setConfirmationAlertModal(true);
  }, []);

  const confirmationModalHide = useCallback(() => {
    setConfirmationAlertModal(false);
  }, []);

  const usersDeleteSuccess = useCallback(async () => {
    loaderStateTrue();
    try {
      const data = { id: [userProfileId] };
      const response = await UserController.userDelete(data);
      if (response[0].data[0].success) {
        setConfirmationAlertModal(false);
        backToWorkerHandler();
        Utility.toastNotifications(response[0].data[0].message, "Success", "success");
      } else {
        Utility.toastNotifications(response[0].data[0].message, "Error", "error");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    } finally {
      loaderStateFalse();
    }
  }, [loaderStateTrue, loaderStateFalse, userProfileId, backToWorkerHandler]);

  const deleteCancleButton = useCallback(() => {
    confirmationModalHide();
  }, [confirmationModalHide]);

  // Reset password handlers
  const resetPassword = useCallback(() => {
    setResetconfirmationAlertModal(true);
  }, []);

  const resetconfirmationModalHide = useCallback(() => {
    setResetconfirmationAlertModal(false);
  }, []);

  const resetPasswordApi = useCallback(async () => {
    loaderStateTrue();
    try {
      const data = userEmail.trim()
        ? { username: userEmail.trim() }
        : { username: phoneNumber };

      const response = await UserController.resetPassword(data);
      if (response?.success) {
        resetconfirmationModalHide();
        Utility.toastNotifications(response.message, "Success", "success");
      } else {
        Utility.toastNotifications(response.message, "Error", "error");
      }
    } catch (error) {
      console.error("Error resetting password:", error);
    } finally {
      loaderStateFalse();
    }
  }, [loaderStateTrue, loaderStateFalse, userEmail, phoneNumber, resetconfirmationModalHide]);

  const resetdeleteConfirmButton = useCallback(() => {
    resetPasswordApi();
  }, [resetPasswordApi]);

  const resetdeleteCancleButton = useCallback(() => {
    resetconfirmationModalHide();
  }, [resetconfirmationModalHide]);

  // Tab UI component
  const tabUi = useMemo(() => {
    const arry = [];

    if (Object.keys(Utility.getRoleObjectByEventKey('user_profile')).length > 0 &&
      Utility.getRoleObjectByEventKey('user_profile').subeventKey.length > 0 &&
      Utility.getRoleObjectByEventKey('user_profile').subeventKey[0].rules != "") {
      arry.push(
        <Tab eventKey="personal" title="Personal" key={0}>
          {selectedTabName === 'personal' && (
            <ErrorBoundary title="Personal Tab Error">
              <Personal
                userProfileId={userProfileId}
                selectedTabName={selectedTabName}
                renderChildTabs={false}
                userStatus={userStatus}
                tabchangeInner={tabchangeInner}
                userEmail={userEmail}
                phoneNumberUpdateSuccessFn={phoneNumberUpdateSuccessFn}
              />
            </ErrorBoundary>
          )}
        </Tab>
      );
    }

    if (Object.keys(Utility.getRoleObjectByEventKey('user_profile')).length > 0 &&
      Utility.getRoleObjectByEventKey('user_profile').subeventKey.length > 0 &&
      Utility.getRoleObjectByEventKey('user_profile').subeventKey[1].rules != "") {
      arry.push(
        <Tab eventKey="professional" title="Professional" key={1}>
          {selectedTabName === 'professional' && (
            <ErrorBoundary title="Professional Tab Error">
              <Professional
                userProfileId={userProfileId}
                selectedTabName={selectedTabName}
                renderChildTabs={false}
                userStatus={userStatus}
                tabchangeInner={tabchangeInner}
                userEmail={userEmail}
                selectedRowsData={selectedRowsData}
              />
            </ErrorBoundary>
          )}
        </Tab>
      );
    }

    return arry;
  }, [selectedTabName, userProfileId, userStatus, tabchangeInner, userEmail, phoneNumberUpdateSuccessFn, selectedRowsData]);

  return (
    <div className={`${profilecontentdispaly} profilemaincontainerBox`}>
      <div className={userStatus ? 'profilemaincontainerinner' : " profilemaincontainerinnerdisabled profilemaincontainerinner"}>
        <div className="profiletopbox">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-9">
                <div className={`${profileImagePreviewShow ? "profileimgsec_top_space" : ""} profileimgsec`}>
                  <button onClick={backToWorkerHandler} className="backtoworker">
                    <i className="fa fa-angle-left" aria-hidden="true"></i>
                  </button>
                  <div className='user_add_img_container userprofileimg desarchiverEmployee'>
                    {profileImageUi()}
                    {profileImagePreviewShow && (
                      <div className="savecancelinner">
                        <button onClick={submitWorkerProfile} className="profileimgsave">Save</button>
                        <button onClick={cancelWorkerProfile} className="profileimgcancel">Cancel</button>
                      </div>
                    )}
                    <div className="errorClass error_div">{profileImageError}</div>
                  </div>
                  <div className="userprofdetails">
                    <h3 className="pronamelabel">
                      {selectedRowsData && (selectedRowsData?.first_name + " " + selectedRowsData?.last_name)?.length > 22 ? (
                        <OverlayTrigger overlay={<Tooltip>{selectedRowsData.first_name + " " + selectedRowsData.last_name}</Tooltip>}>
                          <span>{selectedRowsData.first_name + " " + selectedRowsData.last_name}</span>
                        </OverlayTrigger>
                      ) : (
                        <span>{selectedRowsData?.first_name + " " + selectedRowsData?.last_name}</span>
                      )}
                    </h3>
                    <p className="pronumlabelBox emailidlabel">{selectedRowsData?.email}</p>
                    <p className="pronumlabelBox phonenumber">{selectedRowsData?.contact_number}</p>
                  </div>
                </div>
              </div>
              <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                  show={imageCropModalFlag}
                  onHide={imageCropModalHide}
                  onCancel={imageCropModalHide}
                  onSave={imageCropDataSave}
                  className="modalcustomizeDialog cropmodalcontentDialog"
                  bodyClassName="cropmodalcontentbody"
                  headerclassName="close_btn_icon"
                  title={t('cropimage')}
                  footer={true}
                  closeButton={true}
                  saveButtonLabel={t('crop')}
                  saveButtonClassName="delconfirmbtn btn btn-primary"
                  cancelButtonClassName="delcancelbtn btn btn-primary"
                  body={
                    <ErrorBoundary title="ImageCropContent Error">
                      <ImageCropContent
                        onImageLoaded={onImageLoaded}
                        onComplete={onCropComplete}
                        onCropChange={onCropChange}
                        crop={crop}
                        croppedImageUrl={croppedImageUrl}
                        src={src}
                        onCropComplete={onCropComplete}
                        imageCropModalShow={() => setImageCropModalFlag(true)}
                      />
                    </ErrorBoundary>
                  }
                />
              </ErrorBoundary>
            </div>
          </div>
        </div>

        <div className="profiletabsview">
          <Tabs
            id="homepagetabs"
            activeKey={selectedTabName}
            className="tabsmainboxCon"
            onSelect={handelSelectTab}
          >
            {tabUi}
          </Tabs>
        </div>

        <ErrorBoundary title="ModalGlobal Error">
          <ModalGlobal
            show={tabChangeConfirmModal}
            onHide={tabChangeConfirmModalHide}
            className="modalcustomize confirmationalertmodal"
            bodyClassName="cancelConfirmationbody"
            headerclassName="close_btn_icon"
            title=""
            footer={false}
            body={
              <ErrorBoundary title="ConfirmationAlert Error">
                <ConfirmationAlert
                  BodyFirstContent={t('navigateConfirmation')}
                  BodySecondContent=""
                  BodyThirdContent=""
                  confirmationButtonContent={t('confirm')}
                  cancelButtonContent={t('cancel')}
                  deleteConfirmButton={confirmTabChange}
                  deleteCancleButton={tabChangeConfirmModalHide}
                />
              </ErrorBoundary>
            }
          />
        </ErrorBoundary>

        <ErrorBoundary title="ModalGlobal Error">
          <ModalGlobal
            show={confirmationAlertModal}
            onHide={confirmationModalHide}
            className="modalcustomize confirmationalertmodal"
            bodyClassName="cancelConfirmationbody"
            headerclassName="close_btn_icon"
            title="Delete This Person?"
            footer={false}
            body={
              <ErrorBoundary title="ConfirmationAlert Error">
                <ConfirmationAlert
                  BodyFirstContent={`Are you sure you want to delete ${userName} permanently? You won't be able to go back.`}
                  confirmationButtonContent="Confirm"
                  cancelButtonContent="Cancel"
                  deleteConfirmButton={usersDeleteSuccess}
                  deleteCancleButton={deleteCancleButton}
                />
              </ErrorBoundary>
            }
          />
        </ErrorBoundary>

        <ErrorBoundary title="ModalGlobal Error">
          <ModalGlobal
            show={resetconfirmationAlertModal}
            onHide={resetconfirmationModalHide}
            className="modalcustomize confirmationalertmodal"
            bodyClassName="cancelConfirmationbody"
            headerclassName="close_btn_icon"
            title="Reset User Password?"
            footer={false}
            body={
              <ErrorBoundary title="ConfirmationAlert Error">
                <ConfirmationAlert
                  BodyFirstContent="Are you sure you want to reset"
                  BodySecondContent={userName.length >= 20 ? userName.substring(0, 20) + "..." : userName}
                  BodyThirdContent="password? You won't be able to go back."
                  confirmationButtonContent="Confirm"
                  cancelButtonContent='Cancel'
                  deleteConfirmButton={resetdeleteConfirmButton}
                  deleteCancleButton={resetdeleteCancleButton}
                />
              </ErrorBoundary>
            }
          />
        </ErrorBoundary>
      </div>
    </div>
  );
};

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials,
  token: globalState.mainReducerData.token,
  access_token: globalState.mainReducerData.access_token,
  roleWisePermission: globalState.mainReducerData.roleWisePermission
});

export default connect(mapStateToProps, {
  loaderStateTrue,
  loaderStateFalse,
  setToken,
  setUserCredentials,
  logOutApp
})(withNamespaces()(UserProfile));
